import { useAjouteDemande } from '@/features/interface/demande/ajouter/useAjouteDemande'
import { useRechercheFactureActions } from '@/features/interface/recherches/facture/useRechercheFactureActions'
import {
  navigateTo,
  type NavigateToDemandeExtranet,
  type ToDispositif,
  type NavigateToQueryDossierFormation,
} from '@/router/navigateTo'
import type { DocumentType } from './DocumentCard.types'
import { useDRFActions } from '@/features/interface/recherches/drf/useDRFActions'

export function useAjoutDocumentAction() {
  const { redirectSelfeFacture } = useRechercheFactureActions()
  const storeAddDemande = useAjouteDemande()
   const { addDemandeDRF } = useDRFActions('demande')

  const actions: Partial<Record<DocumentType, () => Promise<void>>> = {
    dossiers: async () => {
      try {
        const demande = await storeAddDemande.showAjoute()
        navigateTo({
          to: 'detail',
          domaine: 'formations',
          module: 'demande',
          dispositif: demande.dispositif.toLowerCase() as ToDispositif,
          sousDispositif: 'sousDispositif' in demande ? demande.sousDispositif : null,
          id: demande.id,
        } as NavigateToDemandeExtranet)
      } catch (err) {
        console.error(err)
      }
    },
    factures: async () => redirectSelfeFacture(),
    remboursements: async () => addDemandeDRF(),
    proforma: async () => {
      navigateTo({
        to: 'recherche',
        domaine: 'formations',
        module: 'dossier',
        query: {
          dispositifs: ['FPE'],
          statuts: ['Accorde', 'Rupture'],
        },
      } as NavigateToQueryDossierFormation)
    },
  }

  const executeAjoutAction = async (type: DocumentType) => {
    const action = actions[type]
    if (action) {
      await action()
    } else {
      console.warn(`Aucune action d'ajout configurée pour : ${type}`)
    }
  }

  const isActionAvailable = (type: DocumentType) => !!actions[type]

  return { executeAjoutAction, isActionAvailable }
}
